// @flow
/* eslint no-shadow: "off" */

import React from 'react';
import { isMobile } from 'react-device-detect';
import { links } from 'core/config';
import { jobs as t } from 'helpers/translation';

type Props = {
  jobAlerts: any,
  search: any,
  updateSearch: Function,
  toggleVisibility: Function
};

export default ({ jobAlerts, search, updateSearch, toggleVisibility }: Props) => {
  const query = {};

  ['q', 'category_ids', 'industry_ids', 'work_type_ids', 'entry_level_ids',
    'job_language_ids', 'number_employees_group_ids', 'region_ids', 'place_id', 'distance'
  ].forEach(key => {
    query[key] = search[key] ? search[key] : [];
  });

  const renderItems = () => (
    jobAlerts.map(({ id, name, keywords, regions, categories, industries, workTypes, entryLevels, jobLanguages, numberEmployeesGroups, place, distance }) => {
      const jobAlertUrlParams = {
        q: keywords ? keywords.trim().replace(/[,.+]/g, ' ').split(' ').join('+') : '',
        category_ids: categories ? categories.map(({ id }) => id) : [],
        industry_ids: industries ? industries.map(({ id }) => id) : [],
        work_type_ids: workTypes ? workTypes.map(({ id }) => id) : [],
        entry_level_ids: entryLevels ? entryLevels.map(({ id }) => id) : [],
        job_language_ids: jobLanguages ? jobLanguages.map(({ id }) => id) : [],
        number_employees_group_ids: numberEmployeesGroups ? numberEmployeesGroups.map(({ id }) => id) : [],
        region_ids: regions ? regions.map(({ id }) => id) : [],
        place_id: place ? place.id : '',
        distance: distance || ''
      };

      const handleClick = () => {
        updateSearch(jobAlertUrlParams);
        toggleVisibility('alerts');
      };

      return (
        <button
          key={id}
          className='filter__item active'
          onClick={() => handleClick()}
          type="button"
        >
          <div className="filter__name">{name}</div>
        </button>
      );
    })
  );

  return (
    <div className="card saved-search">
      <div className="saved-search__title">{t.saved_searches.title}</div>
      <div className="saved-search__items">
        {jobAlerts && renderItems()}
      </div>
      <a
        href={links.job_alerts}
        className={`saved-search__btn btn ${isMobile ? 'btn_secondary btn_extended' : 'btn_xs btn_default' }`}
      >
        {t.btn.edit_job_alerts}
      </a>
    </div>
  );
};
